module.exports = __webpack_public_path__ + "img/lms-reason-1.08009f50.png";